// Module
var code = "<div class=\"landing\"> <section class=\"landing__hero\"> <sw-video videos=\"$ctrl.videos\"></sw-video> <h1>{{ 'gate.landing-page.title' | translate }}</h1> </section> </div> ";
// Exports
export default code;